import { forwardRef, type Ref, type SVGProps } from "react";
const IconLivingRoomOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M8.442 18.202c-.5 0-.907.39-.907.874 0 .482.406.874.907.874h14.663c.5 0 .907-.392.907-.874 0-.483-.406-.874-.907-.874z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29 12.892c0-1.288-1.083-2.331-2.419-2.331v-4.23C26.581 5.043 25.498 4 24.163 4H8.442C7.106 4 6.023 5.043 6.023 6.33v4.231H5.42c-1.337 0-2.42 1.043-2.42 2.33v14.235c0 .483.406.874.907.874s.907-.391.907-.874v-2.582h22.372v2.582c0 .483.406.874.907.874.5 0 .907-.391.907-.874zM4.814 22.796h22.372v-9.904a.594.594 0 0 0-.605-.583h-1.814V6.33a.594.594 0 0 0-.604-.583H8.442a.594.594 0 0 0-.605.583v5.978H5.42a.594.594 0 0 0-.605.583z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLivingRoomOutlineSVG);
ForwardRef.displayName = "IconLivingRoomOutline";
export { ForwardRef as IconLivingRoomOutline };
